import React from "react";
import PlayerAssetsPage from "./PlayerAssetsPage";
import { PLAYER_ASSET_TYPES } from "../../../constants/playerAssetTypes";

const PlayerBackgroundsPage = () => <PlayerAssetsPage config={PLAYER_ASSET_TYPES.background} />;

export default PlayerBackgroundsPage;
